// extracted by mini-css-extract-plugin
export var avatarContainer = "_5y-0";
export var gray = "_5y-f";
export var green = "_5y-c";
export var icon = "_5y-9";
export var image = "_5y-1";
export var lg = "_5y-6";
export var md = "_5y-5";
export var presenceDot = "_5y-b";
export var red = "_5y-d";
export var sm = "_5y-4";
export var status = "_5y-a";
export var xl = "_5y-7";
export var xs = "_5y-3";
export var xxl = "_5y-8";
export var xxs = "_5y-2";
export var yellow = "_5y-e";